import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { Banknote, TrendingUp } from 'lucide-react';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { LinkCard, LinkCardContent, LinkCardDescription, LinkCardHeader, LinkCardTitle } from '@/components/ui/link-card';
import { PageHeading, PageHeadingTitle } from '@/components/ui/page-heading';
import FuturesAppropriatenessTestLayout from '@/features/futures/layouts/appropriateness-test';

const FuturesAppropriatenessTestResultPassedPage = (props: ComponentProps<typeof FuturesAppropriatenessTestLayout>) => {
  const { t } = useTranslation();

  return (
    <FuturesAppropriatenessTestLayout className="space-y-8" progress={1} size="lg" {...props}>
      <PageHeading className="mb-0 -md:text-left" centered>
        <PageHeadingTitle>{t('FuturesAppropriatenessAssessment.result.passed.title')}</PageHeadingTitle>
      </PageHeading>
      <div className="flex flex-col md:flex-row md:items-stretch justify-center gap-4">
        <a className="flex-1" href={`${import.meta.env.VITE_APP_EXCHANGE_URL}/#deposit`}>
          <LinkCard className="md:h-full">
            <LinkCardHeader>
              <GradientIcon className="shrink-0 size-10 md:size-32 md:mx-auto" strokeWidth={1.5}>
                <Banknote />
              </GradientIcon>
            </LinkCardHeader>
            <LinkCardContent>
              <LinkCardTitle asChild>
                <h2 className="md:-mx-4">{t('FuturesAppropriatenessAssessment.result.passed.actions.deposit.title')}</h2>
              </LinkCardTitle>
              <LinkCardDescription>{t('FuturesAppropriatenessAssessment.result.passed.actions.deposit.description')}</LinkCardDescription>
            </LinkCardContent>
          </LinkCard>
        </a>
        <a className="flex-1" href={`${import.meta.env.VITE_APP_EXCHANGE_URL}/futures`}>
          <LinkCard className="md:h-full">
            <LinkCardHeader>
              <GradientIcon className="shrink-0 size-10 md:size-32 md:mx-auto" strokeWidth={1.5}>
                <TrendingUp />
              </GradientIcon>
            </LinkCardHeader>
            <LinkCardContent>
              <LinkCardTitle asChild>
                <h2 className="md:-mx-4">{t('FuturesAppropriatenessAssessment.result.passed.actions.goToExchange.title')}</h2>
              </LinkCardTitle>
              <LinkCardDescription>{t('FuturesAppropriatenessAssessment.result.passed.actions.goToExchange.description')}</LinkCardDescription>
            </LinkCardContent>
          </LinkCard>
        </a>
      </div>
    </FuturesAppropriatenessTestLayout>
  );
};
FuturesAppropriatenessTestResultPassedPage.displayName = 'FuturesAppropriatenessTestResultPassedPage';

export default FuturesAppropriatenessTestResultPassedPage;
